import config from "../config/server-config";
import { apiClient } from "../api";

export const getDestinationsData = async () => {
  try {
    const response = await apiClient.get(config.destinationsPageData, {
      params: { page: "destinations" },
    });
    return response.data;
  } catch (error) {
    return false;
  }
};
